var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFacebookWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 2.5H3.33333C2.8725 2.5 2.5 2.87333 2.5 3.33333V16.6667C2.5 17.1267 2.8725 17.5 3.33333 17.5H10.5125V11.7H8.56417V9.42917H10.5125V7.7625C10.5125 5.825 11.6958 4.76917 13.4292 4.76917C14.0117 4.7675 14.595 4.7975 15.175 4.85833V6.875H13.9792C13.0392 6.875 12.8558 7.32333 12.8558 7.97917V9.425H15.1033L14.8117 11.6958H12.855V17.5H16.6667C17.1275 17.5 17.5 17.1267 17.5 16.6667V3.33333C17.5 2.87333 17.1275 2.5 16.6667 2.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFacebookWhite);
export default __webpack_public_path__ + "static/media/ic_facebook_white.46703a9646f4e34d7dd80f08d320abfb.svg";
export { ForwardRef as ReactComponent };